import { shallowEqual, useSelector } from 'react-redux';
import { createSelector, ParametricSelector } from 'reselect';

import { RootState } from '../reducers';
import { Loading, LoadingState } from '../types';
import { routeToSpecificScope } from '../../helpers/helpersts';

//REVIEW TYPE
const selectLoadingState: ParametricSelector<RootState, string | undefined, Loading> =
  createSelector(
    (state: any, forceScope: any) => forceScope || routeToSpecificScope(state.router.location.pathname),
    (state: any) => state.loading,
    (scope:string, loading:any) => {
      return loading[scope] || { count: 0, message: null };
    }
  );

export const useLoadingState = (forceScope?: string) => {
  return useSelector((state: RootState) => selectLoadingState(state, forceScope), shallowEqual);
};
